import { render, staticRenderFns } from "./Permissions.vue?vue&type=template&id=e7a9314c"
import script from "./Permissions.vue?vue&type=script&lang=ts"
export * from "./Permissions.vue?vue&type=script&lang=ts"
import style0 from "./Permissions.vue?vue&type=style&index=0&id=e7a9314c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports